import React, { memo, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Banner from "./Banner";
import NewTweetForm from "./NewTweetForm";
import TweetCard from "./TweetCard";
import { useAuth } from "../context/AuthContext";

const Tweets = memo(({ tweetService, username, addable }) => {
  const [tweets, setTweets] = useState([]);
  const [error, setError] = useState("");
  const history = useHistory();
  const { user } = useAuth();

  useEffect(() => {
    // 전체 트윗 받아오기
    tweetService
      .getTweets(username)
      .then((tweets) => setTweets([...tweets]))
      .catch(onError);

    /*
    // 소켓 통해 서버가 새로운 트윗 보내고
    // 새로운 트윗 생기면 onCreated 호출해서 트윗 추가
    const stopSync = tweetService.onSync((tweet) => onCreated(tweet));

    // update tweet

    // delete tweet

    return () => stopSync(); // 컴포넌트 언마운트될 때 socket 연결 끊기
*/

    // === ⭐ 소켓 이벤트 연결 시작 ===

    // 2. 생성 (Created) - 새 트윗을 목록 맨 앞에 추가
    const stopCreated = tweetService.onCreated((tweet) => {
      setTweets((prev) => [tweet, ...prev]);
    });

    // 3. 수정 (Updated) - 아이디가 같은 녀석을 찾아서 교체(map)
    const stopUpdated = tweetService.onUpdated((tweet) => {
      setTweets((prev) =>
        prev.map((item) => (item.id === tweet.id ? tweet : item)),
      );
    });

    // 4. 삭제 (Deleted) - 아이디가 같은 녀석을 목록에서 제거(filter)
    const stopDeleted = tweetService.onDeleted((tweetId) => {
      setTweets((prev) => prev.filter((item) => item.id !== tweetId));
    });

    // === 소켓 이벤트 연결 끝 ===

    // cleanup 함수: 컴포넌트가 사라질 때 소켓 연결도 끊어주기
    return () => {
      stopCreated();
      stopUpdated();
      stopDeleted();
    };
  }, [tweetService, username, user]);

  const onCreated = (tweet) => {
    setTweets((tweets) => [tweet, ...tweets]);
  };

  const onDelete = (tweetId) =>
    tweetService
      .deleteTweet(tweetId)
      .then(() =>
        setTweets((tweets) => tweets.filter((tweet) => tweet.id !== tweetId)),
      )
      .catch((error) => setError(error.toString()));

  const onUpdate = (tweetId, text) =>
    tweetService
      .updateTweet(tweetId, text)
      .then((updated) =>
        setTweets((tweets) =>
          tweets.map((item) => (item.id === updated.id ? updated : item)),
        ),
      )
      .catch((error) => error.toString());

  const onUsernameClick = (tweet) => history.push(`/${tweet.username}`);

  const onError = (error) => {
    setError(error.toString());
    setTimeout(() => {
      setError("");
    }, 3000);
  };

  return (
    <>
      {addable && (
        <NewTweetForm
          tweetService={tweetService}
          onError={onError}
          onCreated={onCreated}
        />
      )}
      {error && <Banner text={error} isAlert={true} transient={true} />}
      {tweets.length === 0 && <p className="tweets-empty">No Tweets Yet</p>}
      <ul className="tweets">
        {tweets.map((tweet) => (
          <TweetCard
            key={tweet.id}
            tweet={tweet}
            owner={tweet.username === user.username}
            onDelete={onDelete}
            onUpdate={onUpdate}
            onUsernameClick={onUsernameClick}
          />
        ))}
      </ul>
    </>
  );
});
export default Tweets;
